import { createTheme, Theme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    army: {
      main: string;
      accent: string;
      shield: string;
      textPrimary: string;
      textSecondary: string;
    };
  }
  interface PaletteOptions {
    army: {
      main: string;
      accent: string;
      shield: string;
      textPrimary: string;
      textSecondary: string;
    };
  }
}

const baseTheme = {
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
  },
  shape: {
    borderRadius: 8,
  },
};

export const darkTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#8C9B75',
    },
    secondary: {
      main: '#4F5A46',
    },
    background: {
      default: '#2E3B2D',
      paper: '#2E3B2D',
    },
    army: {
      main: '#2E3B2D',
      accent: '#8C9B75',
      shield: '#4F5A46',
      textPrimary: '#FFFFFF',
      textSecondary: '#B0B5A1',
    },
  },
});

export const lightTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'light',
    primary: {
      main: '#4F5A46',
    },
    secondary: {
      main: '#8C9B75',
    },
    background: {
      default: '#F5F5F5',
      paper: '#FFFFFF',
    },
    army: {
      main: '#2E3B2D',
      accent: '#8C9B75',
      shield: '#4F5A46',
      textPrimary: '#2E3B2D',
      textSecondary: '#4F5A46',
    },
  },
}); 